export const formatDate = (date: string) =>
  new Intl.DateTimeFormat("nl-NL", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).format(Date.parse(date));

export const formatDateTime = (date: string) =>
  new Intl.DateTimeFormat("nl-NL", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  }).format(Date.parse(date));

export const formatPrice = (price: number) =>
  new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
  }).format(price / 100);
